import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface CellContainerProps {
	margin?: string;
	marginLeft?: string;
	status?: string;
}

interface CardRowInfoProps {
	centerText?: boolean;
	disabled?: boolean;
}

interface CardRowInfoLinkProps {
	width?: string;
	align?: string;
	dropdownState?: boolean;
	disabled?: boolean;
	cursor?: string;
}

export const CellContainer = styled.div<CellContainerProps>`
	position: relative;
	width: fit-content;
	display: flex;
	align-items: center;
	gap: 6px;
	max-width: fit-content;
	margin: ${(props) => props?.margin};
	margin-left: ${(props) => props?.marginLeft};
	color: ${(props) => props?.status && 'rgba(0, 0, 0, 0.38)'};
	pointer-events: ${(props) => props?.status && 'none'};
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const CardRowInfo = styled.div<CardRowInfoProps>`
	color: ${(props) => (props?.disabled ? 'rgba(0, 0, 0, 0.38)' : 'black')};
	white-space: normal;
	text-align: ${(props) => props?.centerText && 'center!important;'};
	word-break: break-word;
`;

export const CardRowInfoLink = styled(Link)<CardRowInfoLinkProps>`
	display: block;
	align-items: center;
	gap: 10px;
	width: ${(props) => props?.width || '55%'};
	text-align: ${(props) => props?.align || 'start'};
	text-overflow: ellipsis;
	max-width: 33ch;
	white-space: ${(props) => (props?.dropdownState ? 'normal' : 'nowrap')};
	color: ${(props) => (props?.disabled ? 'rgba(0, 0, 0, 0.38)' : 'black')};
	overflow: hidden;
	font-size: 14px;
	margin: auto 0px;
	line-height: normal;
	cursor: ${(props) => props?.cursor};
`;
